"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChildrenLabelMapper = void 0;
var tslib_1 = require("tslib");
var qualification_codes_1 = require("../../shared/qualification-codes");
var ChildrenLabelMapper = /** @class */ (function () {
    function ChildrenLabelMapper(conditionCodes) {
        this._girlsConditionsCodes = qualification_codes_1.CHILD_AGE_GENDER.GIRLS_CONDITIONS_CODES;
        this._boysConditionsCodes = qualification_codes_1.CHILD_AGE_GENDER.BOYS_CONDITIONS_CODES;
        this._conditionCodes = conditionCodes.sort();
    }
    ChildrenLabelMapper.prototype._conditionIndexToValue = function (conditionIndex) {
        return conditionIndex > 10 ? conditionIndex - 10 : conditionIndex + 1;
    };
    ChildrenLabelMapper.prototype.label = function () {
        if (this._conditionCodes.includes(qualification_codes_1.CHILD_AGE_GENDER.NO_CHILDREN_CHILD_AGE_QUOTA)) {
            return 'No Children';
        }
        return "".concat(this._audiance(), ", Have Children, ").concat(this._buildFrom(), " - ").concat(this._conditionIndexToValue(this._conditionCodeIndex(this.to())), ", ").concat(this._timeUnit());
    };
    ChildrenLabelMapper.prototype._buildFrom = function () {
        if (this._hasBothAgeUnits()) {
            return 0;
        }
        return this._conditionIndexToValue(this._conditionCodeIndex(this.from()));
    };
    ChildrenLabelMapper.prototype._audiance = function () {
        if (this._haveBoy() && this._haveGirl()) {
            return 'Either';
        }
        if (this._haveBoy()) {
            return 'Boy';
        }
        return 'Girl';
    };
    ChildrenLabelMapper.prototype._timeUnit = function () {
        return this.to() > 132 ? 'Years' : 'Months';
    };
    ChildrenLabelMapper.prototype.min = function () {
        return this._conditionIndexToValue(this._conditionCodeIndex(this.from()));
    };
    ChildrenLabelMapper.prototype.max = function () {
        return this._conditionIndexToValue(this._conditionCodeIndex(this.to()));
    };
    ChildrenLabelMapper.prototype.to = function () {
        return this._conditionCodes[this._conditionCodes.length - 1];
    };
    ChildrenLabelMapper.prototype.from = function () {
        return this._conditionCodes[0];
    };
    ChildrenLabelMapper.prototype._haveGirl = function () {
        return this._conditionCodes.some(this._isGirlConditionCode);
    };
    ChildrenLabelMapper.prototype._haveBoy = function () {
        return this._conditionCodes.some(this._isBoyConditionCode);
    };
    ChildrenLabelMapper.prototype._isBoyConditionCode = function (conditionCode) {
        return conditionCode % 2 > 0;
    };
    ChildrenLabelMapper.prototype._isGirlConditionCode = function (conditionCode) {
        return conditionCode % 2 === 0;
    };
    ChildrenLabelMapper.prototype._conditionCodeIndex = function (conditionCode) {
        if (this._isBoyConditionCode(conditionCode)) {
            return this._boysConditionsCodes.findIndex(function (code) { return code === conditionCode; });
        }
        return this._girlsConditionsCodes.findIndex(function (code) { return code === conditionCode; });
    };
    ChildrenLabelMapper.prototype._includeMonths = function () {
        return this._conditionCodes.some(function (code) {
            return tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(qualification_codes_1.CHILD_AGE_GENDER.BOYS_MONTHS), false), tslib_1.__read(qualification_codes_1.CHILD_AGE_GENDER.GIRLS_MONTHS), false).includes(code);
        });
    };
    ChildrenLabelMapper.prototype._includeYears = function () {
        return this._conditionCodes.some(function (code) {
            return tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(qualification_codes_1.CHILD_AGE_GENDER.BOYS_YEARS), false), tslib_1.__read(qualification_codes_1.CHILD_AGE_GENDER.GIRLS_YEARS), false).includes(code);
        });
    };
    ChildrenLabelMapper.prototype._hasBothAgeUnits = function () {
        return this._includeMonths() && this._includeYears();
    };
    return ChildrenLabelMapper;
}());
exports.ChildrenLabelMapper = ChildrenLabelMapper;
